var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNeutralColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 155,
    fill: "none",
    viewBox: "0 0 154 155",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 76.665,
    cy: 77.665,
    r: 76.665,
    fill: "#89CAFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#21214D",
    d: "m55.294 127.25.074.039c2.318 1.015 5.634-.028 7.962-1.952 3.12-2.605 6.66-4.669 10.42-6.192 3.051-1.374 6.46-2.46 10.11-3.154 3.665-.699 7.234-.942 10.596-.775 4.04.037 8.074.658 11.914 1.925 2.872.937 6.339.685 8.123-1.109l.071-.067c1.774-1.753.613-4.866-3.035-6.448-8.02-3.467-17.267-4.651-26.497-3.693-1 .142-2.006.3-3.02.493a65.624 65.624 0 0 0-2.999.652c-8.934 2.502-17.097 7.002-23.265 13.169-2.828 2.815-2.766 6.137-.454 7.112ZM61.344 63.307c0 7.747-5.47 14.026-12.216 14.026-6.748 0-12.217-6.28-12.217-14.026 0-7.747 5.469-14.027 12.217-14.027 6.747 0 12.216 6.28 12.216 14.027ZM116.424 63.307c0 7.747-5.469 14.026-12.217 14.026-6.747 0-12.216-6.28-12.216-14.026 0-7.747 5.469-14.027 12.216-14.027 6.748 0 12.217 6.28 12.217 14.027Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.21 59.144a4.435 4.435 0 1 1-8.87 0 4.435 4.435 0 0 1 8.87 0ZM106.29 59.144a4.435 4.435 0 1 1-8.87-.001 4.435 4.435 0 0 1 8.87.001Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNeutralColor);
export default __webpack_public_path__ + "static/media/icon-neutral-color.08a61105ad59acc6a8355ecc5484e410.svg";
export { ForwardRef as ReactComponent };